import React from 'react'
import { Container, Row, Col, Label, Input } from 'reactstrap'

class AddressViewController extends React.Component{

    render() {
        return (
            <Container>
                <Row>
                    <Col>
                        <Label style={{'fontSize': '20pt', 'fontWeight': '400'}}>{this.props.title || 'Shipping Address'}</Label>
                    </Col>
                </Row>
                <Row xs="1" sm="2">
                    <Col>
                        <Container>
                            <Row>
                                <Col>
                                    <Label>First Name</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Input value={this.props.model.first_name}
                                        onChange={(e) => this.props.onUpdate('first_name', e.target.value)} />
                                </Col>
                            </Row>
                        </Container>
                    </Col>
                    <Col>
                        <Container>
                            <Row>
                                <Col>
                                    <Label>Last Name</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Input value={this.props.model.last_name}
                                        onChange={(e) => this.props.onUpdate('last_name', e.target.value)} />
                                </Col>
                            </Row>
                        </Container>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Container>
                            <Row>
                                <Col>
                                    <Label>Company</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Input value={this.props.model.company}
                                        onChange={(e) => this.props.onUpdate('company', e.target.value)} />
                                </Col>
                            </Row>
                        </Container>
                    </Col>
                </Row>
                <Row xs="1" sm="2">
                    <Col>
                        <Container>
                            <Row>
                                <Col>
                                    <Label>Email</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Input value={this.props.model.email}
                                        onChange={(e) => this.props.onUpdate('email', e.target.value)} />
                                </Col>
                            </Row>
                        </Container>
                    </Col>
                    <Col>
                        <Container>
                            <Row>
                                <Col>
                                    <Label>Phone Number</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Input value={this.props.model.phonenumber}
                                        onChange={(e) => this.props.onUpdate('phonenumber', e.target.value)} />
                                </Col>
                            </Row>
                        </Container>
                    </Col>
                </Row>
                <Row xs="1" sm="2">
                    <Col>
                        <Container>
                            <Row>
                                <Col>
                                    <Label>Street Address</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Input value={this.props.model.street_address}
                                        onChange={(e) => this.props.onUpdate('street_address', e.target.value)} />
                                </Col>
                            </Row>
                        </Container>
                    </Col>
                    <Col>
                        <Container>
                            <Row>
                                <Col>
                                    <Label>Apartment, Suite, Building (Optional)</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Input value={this.props.model.apartment}
                                        onChange={(e) => this.props.onUpdate('apartment', e.target.value)} />
                                </Col>
                            </Row>
                        </Container>
                    </Col>
                </Row>
                <Row xs='1' sm='3'>
                    <Col xs='12' sm='6'>
                        <Container>
                            <Row>
                                <Col>
                                    <Label>City</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Input value={this.props.model.city}
                                        onChange={(e) => this.props.onUpdate('city', e.target.value)} />
                                </Col>
                            </Row>
                        </Container>
                    </Col>
                    <Col xs='6' sm='3'>
                        <Container>
                            <Row>
                                <Col>
                                    <Label>State</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Input value={this.props.model.state}
                                        onChange={(e) => this.props.onUpdate('state', e.target.value)} />
                                </Col>
                            </Row>
                        </Container>
                    </Col>
                    <Col xs='6' sm='3'>
                        <Container>
                            <Row>
                                <Col>
                                    <Label>Zip Code</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Input value={this.props.model.zip}
                                        onChange={(e) => this.props.onUpdate('zip', e.target.value)} />
                                </Col>
                            </Row>
                        </Container>
                    </Col>
                </Row>
            </Container>
        )
    }
}

export { AddressViewController }
